import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Calendar, BarChart2, Clock, TrendingUp, AlertTriangle, CheckCircle, XCircle } from 'lucide-react';
import { AnalyticsCards } from './AnalyticsCards';
import { UpcomingScreenings } from './UpcomingScreenings';
import { RecentCandidates } from './RecentCandidates';
export const DashboardHome = () => {
  const analyticsData = [{
    label: 'Active Candidates',
    value: '143',
    change: '+12%',
    trend: 'up',
    icon: <Users size={20} className="text-indigo-600" data-id="element-1005" />
  }, {
    label: 'Completed Screenings',
    value: '28',
    change: '+5%',
    trend: 'up',
    icon: <CheckCircle size={20} className="text-green-600" data-id="element-1006" />
  }, {
    label: 'Avg. Quality Score',
    value: '87/100',
    change: '+3%',
    trend: 'up',
    icon: <BarChart2 size={20} className="text-indigo-600" data-id="element-1007" />
  }, {
    label: 'Time Saved',
    value: '128 hrs',
    change: '+15%',
    trend: 'up',
    icon: <Clock size={20} className="text-indigo-600" data-id="element-1008" />
  }];
  const upcomingScreenings = [{
    name: 'James Wilson',
    position: 'Frontend Developer',
    time: 'Today, 2:30 PM',
    status: 'Confirmed'
  }, {
    name: 'Sophia Garcia',
    position: 'Data Scientist',
    time: 'Today, 4:15 PM',
    status: 'Confirmed'
  }, {
    name: 'Robert Taylor',
    position: 'DevOps Engineer',
    time: 'Tomorrow, 10:00 AM',
    status: 'Pending'
  }, {
    name: 'Emily Johnson',
    position: 'Marketing Manager',
    time: 'Tomorrow, 1:30 PM',
    status: 'Confirmed'
  }];
  return <div className="container mx-auto" data-id="element-1009">
      <div className="mb-6" data-id="element-1010">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1011">Dashboard</h1>
        <p className="text-gray-600" data-id="element-1012">
          Welcome back, John. Here's what's happening with your candidates
          today.
        </p>
      </div>
      <AnalyticsCards data={analyticsData} data-id="element-1013" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6" data-id="element-1014">
        <div className="lg:col-span-2" data-id="element-1015">
          <div className="bg-white rounded-lg shadow p-6" data-id="element-1016">
            <div className="flex justify-between items-center mb-6" data-id="element-1017">
              <h2 className="text-lg font-medium" data-id="element-1018">Candidate Pipeline</h2>
              <Link to="/dashboard/candidates" className="text-sm text-indigo-600 hover:text-indigo-800" data-id="element-1019">
                View all candidates
              </Link>
            </div>
            <div className="space-y-6" data-id="element-1020">
              <div className="grid grid-cols-4 gap-4" data-id="element-1021">
                {[{
                label: 'New Applications',
                count: 37,
                icon: <Users size={18} data-id="element-1022" />,
                color: 'bg-blue-100 text-blue-600'
              }, {
                label: 'Screening',
                count: 24,
                icon: <Calendar size={18} data-id="element-1023" />,
                color: 'bg-yellow-100 text-yellow-600'
              }, {
                label: 'Interview',
                count: 12,
                icon: <Clock size={18} data-id="element-1024" />,
                color: 'bg-purple-100 text-purple-600'
              }, {
                label: 'Offer',
                count: 5,
                icon: <CheckCircle size={18} data-id="element-1025" />,
                color: 'bg-green-100 text-green-600'
              }].map((stage, index) => <div key={index} className="bg-white border border-gray-200 rounded-lg p-4 flex flex-col items-center" data-id="element-1026">
                    <div className={`w-10 h-10 rounded-full ${stage.color} flex items-center justify-center mb-2`} data-id="element-1027">
                      {stage.icon}
                    </div>
                    <div className="text-2xl font-bold" data-id="element-1028">{stage.count}</div>
                    <div className="text-xs text-gray-500 text-center" data-id="element-1029">
                      {stage.label}
                    </div>
                  </div>)}
              </div>
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1030">
                <div className="flex justify-between items-center mb-4" data-id="element-1031">
                  <h3 className="text-sm font-medium" data-id="element-1032">
                    Hiring Pipeline Progress
                  </h3>
                  <div className="text-xs text-gray-500" data-id="element-1033">
                    78 total candidates
                  </div>
                </div>
                <div className="h-4 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-1034">
                  <div className="flex h-full" data-id="element-1035">
                    <div className="bg-blue-500 h-full" style={{
                    width: '47%'
                  }} data-id="element-1036"></div>
                    <div className="bg-yellow-500 h-full" style={{
                    width: '31%'
                  }} data-id="element-1037"></div>
                    <div className="bg-purple-500 h-full" style={{
                    width: '15%'
                  }} data-id="element-1038"></div>
                    <div className="bg-green-500 h-full" style={{
                    width: '7%'
                  }} data-id="element-1039"></div>
                  </div>
                </div>
                <div className="flex justify-between mt-2 text-xs text-gray-500" data-id="element-1040">
                  <div data-id="element-1041">Application</div>
                  <div data-id="element-1042">Screening</div>
                  <div data-id="element-1043">Interview</div>
                  <div data-id="element-1044">Offer</div>
                  <div data-id="element-1045">Hired</div>
                </div>
              </div>
            </div>
            <div className="mt-6" data-id="element-1046">
              <h3 className="text-sm font-medium mb-4" data-id="element-1047">Recent Candidates</h3>
              <RecentCandidates data-id="element-1048" />
            </div>
          </div>
        </div>
        <div data-id="element-1049">
          <div className="bg-white rounded-lg shadow p-6 mb-6" data-id="element-1050">
            <div className="flex justify-between items-center mb-4" data-id="element-1051">
              <h2 className="text-lg font-medium" data-id="element-1052">Upcoming Screenings</h2>
              <Link to="/dashboard/schedule" className="text-sm text-indigo-600 hover:text-indigo-800" data-id="element-1053">
                View all
              </Link>
            </div>
            <UpcomingScreenings screenings={upcomingScreenings} data-id="element-1054" />
          </div>
          <div className="bg-white rounded-lg shadow p-6" data-id="element-1055">
            <h2 className="text-lg font-medium mb-4" data-id="element-1056">Screening Quality</h2>
            <div className="space-y-4" data-id="element-1057">
              <div data-id="element-1058">
                <div className="flex justify-between mb-1" data-id="element-1059">
                  <span className="text-sm font-medium" data-id="element-1060">Completion Rate</span>
                  <span className="text-sm text-gray-500" data-id="element-1061">92%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-1062">
                  <div className="bg-green-600 h-2 rounded-full" style={{
                  width: '92%'
                }} data-id="element-1063"></div>
                </div>
              </div>
              <div data-id="element-1064">
                <div className="flex justify-between mb-1" data-id="element-1065">
                  <span className="text-sm font-medium" data-id="element-1066">Bot Detection</span>
                  <span className="text-sm text-gray-500" data-id="element-1067">8 flagged</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-1068">
                  <div className="bg-red-600 h-2 rounded-full" style={{
                  width: '8%'
                }} data-id="element-1069"></div>
                </div>
              </div>
              <div data-id="element-1070">
                <div className="flex justify-between mb-1" data-id="element-1071">
                  <span className="text-sm font-medium" data-id="element-1072">Data Quality</span>
                  <span className="text-sm text-gray-500" data-id="element-1073">87%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-1074">
                  <div className="bg-indigo-600 h-2 rounded-full" style={{
                  width: '87%'
                }} data-id="element-1075"></div>
                </div>
              </div>
            </div>
            <div className="mt-6 space-y-3" data-id="element-1076">
              <div className="flex items-start p-3 bg-yellow-50 text-yellow-800 rounded-md" data-id="element-1077">
                <AlertTriangle size={16} className="mr-2 flex-shrink-0 mt-0.5" data-id="element-1078" />
                <div data-id="element-1079">
                  <p className="text-sm font-medium" data-id="element-1080">Attention needed</p>
                  <p className="text-xs" data-id="element-1081">
                    3 candidates have inconsistent responses
                  </p>
                </div>
              </div>
              <div className="flex items-start p-3 bg-green-50 text-green-800 rounded-md" data-id="element-1082">
                <TrendingUp size={16} className="mr-2 flex-shrink-0 mt-0.5" data-id="element-1083" />
                <div data-id="element-1084">
                  <p className="text-sm font-medium" data-id="element-1085">Improving quality</p>
                  <p className="text-xs" data-id="element-1086">
                    Screening quality up 5% from last week
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};